import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker so the app is installable on Android /
// Chrome / desktop and gets a fast repeat-visit start.  iOS Safari relies on
// the manifest + apple-touch-icon (already in index.html) for Add-to-Home-Screen.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Non-fatal: the app still works without the SW; PWA install just
      // falls back to online-only.
      // eslint-disable-next-line no-console
      console.warn('Service worker registration failed:', err);
    });
  });
  // If the SW detects the server has returned SPA HTML for a hashed
  // .js request (stale bundle after deploy), it posts this message so
  // the client force-reloads onto the fresh index.html referencing the
  // current bundle. See /public/sw.js (Tudor Fix H1, 1 Oct 2026).
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event && event.data && event.data.type === 'ARP_STALE_BUNDLE_RELOAD') {
      // Guard against reload loops: only reload once per page session.
      if (!window.__arp_reloaded_once) {
        window.__arp_reloaded_once = true;
        window.location.reload();
      }
    }
  });
}

